import React, { useState, useEffect } from "react";
import {Form } from 'react-bootstrap'
import { Link } from "gatsby";
import loadable from "@loadable/component"

import { calculateMonthlyPayment, CalculatorFields, CalDefault } from "../../common/utils/mortgage"
import { addCommas, numericWithDecimal } from "../../common/utils/site_utlis"

import {currency} from "../../common/constant"
import {PageLinks} from "../../common/page-links"


const Select = loadable(() => import("react-select"));

const MortgageCalculator = () => {
    
    var initial_amount = "1000000"
    var down_payment = (20/100) * initial_amount;

    const [error_msg, setErrorMsg] = useState('');

    const [calculator_value, setCalculatorValue] = useState(
        {
            //'loan_amount': (price) - down_payment,
            'loan_amount': initial_amount,
            'interest_rate': CalDefault.interest_rate,
            'amortization': CalDefault.amortization,
            'down_payment': down_payment
        }
    );

    const handleChange = (event, field_name) => {

        //console.log("event_target", event.value)

        if (parseFloat(numericWithDecimal(document.getElementById("down_payment").value)) > parseFloat(numericWithDecimal(document.getElementById("loan_amount").value))) {
            setErrorMsg("Deposit should not be greater than price.")
        } else {
            setErrorMsg("");
        }

        if (event?.target?.name === "interest_rate") {
            setCalculatorValue({ ...calculator_value, [event.target.name]: event.target.value > CalculatorFields.InterestMax ? CalculatorFields.InterestMax : numericWithDecimal(event.target.value) })
        } else {
            if (field_name === "amortization") {
                if (parseInt(event.value) > 35) {

                } else {
                    setCalculatorValue({ ...calculator_value, [field_name]: numericWithDecimal(event.value) })
                }
            } else {
                setCalculatorValue({ ...calculator_value, [event?.target?.name]: numericWithDecimal(event.target.value) })
            }
        }

    }

    const handleBlur = (event) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "calculator",
          formType: "Mortgage Calculator",
          formName: "Mortgage Calculator",
          formLabel: "Mortgage Calculator"
        });
    };

    const options = [
        { value: '25', label: '25 years' },
        { value: '30', label: '30 years' },
        { value: '35', label: '35 years' }
    ]

    var mortgage_monthly_payment = parseFloat(calculateMonthlyPayment(calculator_value.loan_amount, calculator_value.interest_rate, calculator_value.down_payment, calculator_value.amortization)).toFixed(2);

    return (
        <React.Fragment>
            <div className="calculator-form">
                <Form action="javascript:;">
                    {error_msg && <div className="alert alert-danger col-12 p-3">{error_msg}</div>}

                    <Form.Group className="form-wrap">
                        <Form.Label>Price ({currency})</Form.Label>
                        <Form.Control placeholder={""} type="text" name="loan_amount" id="loan_amount" value={addCommas(calculator_value.loan_amount)} onChange={handleChange} onBlur={handleBlur} maxLength={CalculatorFields.PriceInputMax} />
                    </Form.Group>
                    <Form.Group className="form-wrap">
                        <Form.Label>Deposit ({currency})</Form.Label>
                        <Form.Control type="text" placeholder={"0"} name="down_payment" id="down_payment" value={addCommas(calculator_value.down_payment)} onChange={handleChange} onBlur={handleBlur} maxLength={CalculatorFields.PriceInputMax} />
                    </Form.Group>
                    <Form.Group className="form-wrap">
                        <Form.Label>Repayment Term</Form.Label>
                        <Select options={options} placeholder="25 years" name="amortization" className="react-select form-control" classNamePrefix="react-select" onChange={(e) => handleChange(e, "amortization")} onBlur={handleBlur} />
                    </Form.Group>
                    <Form.Group className="form-wrap">
                        <Form.Label>Interest Rate (%)</Form.Label>
                        <Form.Control className="sml_wdth" placeholder="0" type="text" name="interest_rate" value={numericWithDecimal(calculator_value.interest_rate)} onChange={handleChange} onBlur={handleBlur} maxLength={CalculatorFields.InterestInputMax} />
                    </Form.Group>
                </Form>

                <div className="calc-bottom">
                    <div className="calc-res">
                        <span>Mortgage Repayments:</span>
                        <div className="final-res">{currency}{parseInt(mortgage_monthly_payment) > 0 ? addCommas(mortgage_monthly_payment) : 0}/month</div>
                    </div>
                    <Link to={`/${PageLinks.request_valuation}/`} className="btn btn-primary">Get a free valuation</Link>
                </div>
            </div>
        </React.Fragment>
    );
};
export default MortgageCalculator;
